import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import {
  AutoSizer,
  Table,
  Column,
  TableHeaderRowProps,
} from 'react-virtualized';
import 'react-virtualized/styles.css'; // styles
import { ClassNameMap } from '@material-ui/styles';
import { TableColumn } from './virtualized-table-types';

const useStyles = makeStyles((theme: Theme) => ({
  tableWrapper: {
    marginBottom: 10,
  },
  header: {
    backgroundColor: `${theme.palette.primary.dark}`,
    color: '#fff',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    textTransform: 'uppercase',
    '& > div': {
      display: 'flex',
    },
  },
  row: {
    borderBottom: `1px solid ${theme.palette.primary.light}20`,
    fontWeight: 500,
  },
}));

export const VirtualizedTable = <T,>({
  data,
  columns,
  tableName,
  headerActionButton,
}: {
  data: T[];
  columns: TableColumn<T>[];
  tableName: string | React.ReactNode;
  headerActionButton?: React.ReactNode;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.tableWrapper}>
      <div>
        {`${tableName} [${data.length}]`} {headerActionButton}
      </div>

      {data.length > 0 ? (
        <AutoSizer disableHeight>
          {({ width }) => (
            <Table
              width={width}
              height={180}
              rowHeight={30}
              rowCount={data.length}
              headerHeight={40}
              rowGetter={({ index }) => data[index]}
              headerRowRenderer={(props) =>
                headerRowRenderer({ ...props, classes })
              }
              noRowsRenderer={noRowsRenderer}
              rowClassName={classes.row}
            >
              {columns.map((column) => {
                const { CellComponent, datakey, name, width } = column;

                return (
                  <Column
                    key={datakey}
                    dataKey={datakey}
                    label={name}
                    width={width}
                    flexShrink={0}
                    disableSort
                    cellRenderer={(props) =>
                      CellComponent !== undefined ? (
                        <CellComponent
                          {...props}
                          cellData={props.cellData}
                          rowData={props.rowData}
                        />
                      ) : (
                        <span>
                          {props.cellData != null ? props.cellData : '-'}
                        </span>
                      )
                    }
                  />
                );
              })}
            </Table>
          )}
        </AutoSizer>
      ) : (
        <></>
      )}
    </div>
  );
};

const headerRowRenderer = ({
  columns,
  style,
  classes,
}: TableHeaderRowProps & { classes: ClassNameMap }) => {
  return (
    <div style={style} className={classes.header}>
      {columns}
    </div>
  );
};

const noRowsRenderer = () => <span>Žádné položky k zobrazení.</span>;
